<template lang="pug">
.table-statement
  .table-responsive
    table.table.table-new
      thead
        tr
          th {{ $t("ui.date") }}
          th {{ $t("ui.transfer_amount") }}
          th {{ $t("ui.winlose") }}
          th {{ $t("ui.turnover") }}
          th {{ $t("ui.valid_turnover") }}
          th {{ $t("ui.account_closing") }}
          //- th {{ $t("ui.account_balance") }}
      template(v-if="!loading")
        tbody(v-if="statementList && statementList.length > 0")
          tr(v-for="item in statementList")
            td {{ $moment(item.working_date).format("YYYY-MM-DD") }}
            td {{ $numeral(item.transfer_amount).format("0,0.00") }}
            td
              a(href="javascript:void(0);" @click='redirect($moment(item.working_date).format("YYYY-MM-DD"))')
                span(:class="$helpers.getNumberClass(item.winlose)") {{ $numeral(item.winlose).format("0,0.00") }}
                i.fas.fa-chevron-circle-right(style="margin-left: 5px;")
            td
              span(:class="$helpers.getNumberClass(item.turnover)") {{ $numeral(item.turnover).format("0,0.00") }}
            td
              span(:class="$helpers.getNumberClass(item.valid_turnover)") {{ $numeral(item.valid_turnover).format("0,0.00") }}
            td
              span(:class="$helpers.getNumberClass(item.account_closing)") {{ $numeral(item.account_closing).format("0,0.00") }}
            //- td
            //-   span(:class="$helpers.getNumberClass(item.account_balance)") {{ $numeral(item.account_balance).format("0,0.00") }}
        tbody(v-else)
          tr
            td(colspan=7) {{ $t('ui.no_record') }}
      template(v-else)
        tbody
          tr
            td(colspan=7) 
              i.fas.fa-sync.fa-spin
</template>

<script>
export default {
  components: { },
  data() {
    return {
      loading: false,
      feedback: {
        success: true,
        status: ""
      },
      statementList: []
    }
  },
  validations: { },
  computed: {
    isLoggedIn(){
      return this.$store.getters.isLoggedIn
    },
    accountID() {
      return this.$store.getters.accountID
    },
    sessionToken() {
      return this.$store.getters.sessionToken
    }
  },
  mounted(){
    this.dailyStatement()
  },
  methods:{
    dailyStatement() {
      if (this.isLoggedIn) {
        this.loading = true
        let login_id = this.accountID
        let auth_token = this.sessionToken
        this.$store
          .dispatch("user/dailyStatement", { login_id, auth_token })
          .then(response => {
            this.loading = false
            this.feedback.success = response.success
            this.feedback.status = response.status
            if (this.feedback.success == true) {
              // this.statementList = response.data.statement
              this.statementList = (response.data.statement).sort(function(a,b){
                return new Date(b.working_date) - new Date(a.working_date);
              });
            } else {
              this.$helpers.showDialog(this.$t("ui.cancel"), this.$t("message.list." + response.status), "error")
            }
          })
          .catch(response => {
            this.loading = false
            this.feedback.success = false
            this.feedback.status = this.$t("error." + response.status)
            this.$helpers.showDialog(this.$t("ui.cancel"), this.$t("message.list." + response.status), "error")
          })
      }
    },
    redirect(working_date){
      this.$store.dispatch("user/setWorkingDate", working_date)
      this.$emit("redirectBet", 2)
    }
  }
}
</script>